import { useAlertsStore } from "~/store/alerts/alerts.store";
import { useSseStream } from "~/composables/realtime/useSseStream";
import { SseEventType } from "~/utils/enums/sse.enums";

// useAlertsStream() → registers alert-specific SSE handlers on the shared stream
export const useAlertsStream = () => {
  const alertsStore = useAlertsStore();
  const { onEvent } = useSseStream();

  let unsubscribe: (() => void) | null = null;

  const start = () => {
    if (unsubscribe) return;

    // Initial fetch to have the count before any SSE event arrives
    alertsStore.fetchActiveAlertsCount();

    unsubscribe = onEvent((type) => {
      if (type !== SseEventType.SESSION_ALERTS_UPDATED) return;

      // Always refresh global bell count
      alertsStore.fetchActiveAlertsCount();
    });
  };

  const stop = () => {
    unsubscribe?.();
    unsubscribe = null;
  };

  return {
    start,
    stop,
  };
};
